// extracted by mini-css-extract-plugin
module.exports = {"Mirador":"Mirador_Mirador__SApNi","Image":"Mirador_Image__1R2me","Title":"Mirador_Title__2GaKt"};